"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockFinalClaim = void 0;
var constants_1 = require("@hobt/constants");
var constants_2 = require("../constants");
var cash_receipt_1 = require("./cash-receipt");
exports.mockFinalClaim = {
    newInternalAttachmentFlag: false,
    newInternalCommentFlag: false,
    newExternalAttachmentFlag: false,
    newExternalCommentFlag: false,
    approvedLenderFinancialInstitutionCode: '000',
    approvedLenderReferenceNumber: '00000',
    approvedLenderTransitNumber: '00000',
    claimTypeIndicator: 1,
    cmhcLoanAccountNumber: 10001000,
    exceptionToListingFlag: false,
    partialPaymentReceivedFlag: 'true',
    recordCreatedTimestamp: '2021-06-09 17:51:59.444000',
    recordCreatedUserID: 'b7e336bb-5c0f-4779-976f-a9acb5037fe4',
    recordUpdatedTimestamp: '2021-06-09 17:51:59.444000',
    recordUpdatedUserID: 'b7e336bb-5c0f-4779-976f-a9acb5037fe4',
    rentalIncomeReceivedFlag: 'true',
    sequenceNumber: 1,
    applicableRate: {
        goodsAndServiceTaxRealEstateRatePercent: 3,
        harmonizedSalesTaxRealEstateRatePercent: 3,
        legalActionTimeOfDayCount: 4,
        maximumAppraisalEditAmount: 123,
        maximumEditAssignmentAmount: 456,
        maximumEditDeficitAmount: 123,
        maximumEditTitleAmount: 456,
        propertyManagementFeeAmount: 123,
        provinceID: constants_1.StatisticsCanadaProvinceID.NewfoundlandAndLabrador,
        provincialSalesTaxRealEstateRatePercent: 3,
        realEstateCommissionRatePercent: 3,
    },
    assessment: {
        receivedLastCompleteInstallmentPaidDueDate: '2021-05-20',
        receivedDefaultInterestRatePercent: 11,
        receivedOutstandingPrincipalBalanceAmount: 111,
        receivedTaxAccountBalanceAmount: 123,
        acceptableDefaultInterestRatePercent: 660,
        acceptableLastCompleteInstallmentPaidDueDate: '2021-06-09',
        acceptableDeficiencySaleClosingDate: '2021-06-09',
        acceptableDeficiencySaleCommissionAmount: 370,
        acceptableDeficiencySalePriceAmount: 20,
        acceptableOutstandingPrincipalBalanceAmount: 490,
        acceptableTaxAccountBalanceAmount: 240,
        adjustedConveyancingDateLenderNotificationDate: '2021-06-09',
        adjustedDefaultInterestRatePercent: 980,
        adjustedLastCompleteInstallmentPaidDueDate: '2021-06-09',
        adjustedDeficiencySaleClosingDate: '2021-06-09',
        adjustedDeficiencySaleCommissionAmount: 920,
        adjustedDeficiencySalePriceAmount: 920,
        adjustedOutstandingPrincipalBalanceAmount: 49,
        adjustedTaxAccountBalanceAmount: 310,
        approvedLastCompleteInstallmentPaidDueDate: '2021-06-09',
        approvedOutstandingPrincipalBalanceAmount: 680,
        approvedTaxAccountBalanceAmount: 630,
        previouslyApprovedConveyancingDateLenderNotificationDate: '2021-06-01',
        previouslyApprovedDefaultInterestRatePercent: 5.4,
        previouslyApprovedDeficiencySaleClosingDate: '2021-06-01',
        previouslyApprovedDeficiencySaleCommissionAmount: 100,
        previouslyApprovedDeficiencySalePriceAmount: 100,
        previouslyApprovedLastCompleteInstallmentPaidDueDate: '2021-06-01',
        previouslyApprovedOutstandingPrincipalBalanceAmount: 100,
        previouslyApprovedTaxAccountBalanceAmount: 100,
        accruedInterestCalculations: [
            {
                typeCode: 1,
                balanceAmount: 890,
                endDate: '2021-06-09',
                interestAmount: 170,
                adjustedDefaultInterestRatePercent: 600,
                numberOfDaysCount: 92,
                startDate: '2021-06-09',
            },
            {
                typeCode: 2,
                balanceAmount: 420,
                endDate: '2021-06-09',
                interestAmount: 850,
                adjustedDefaultInterestRatePercent: 230,
                numberOfDaysCount: 680,
                startDate: '2021-06-09',
            },
            {
                typeCode: 3,
                adjustedDefaultInterestRatePercent: 9,
            },
            {
                typeCode: 4,
                adjustedDefaultInterestRatePercent: 7,
            },
        ],
        creditOfReceiptInterestCalculations: [
            {
                typeCode: 1,
                balanceAmount: 520,
                endDate: '2021-06-09',
                numberOfDaysCount: 760,
                startDate: '2021-06-09',
                unpaidInterestAmount: 670,
                interimBalanceAmount: 100,
                cashReceiptItemNumber: 1,
            },
            {
                typeCode: 2,
                balanceAmount: 210,
                endDate: '2021-06-09',
                numberOfDaysCount: 790,
                startDate: '2021-06-09',
                unpaidInterestAmount: 810,
                interimBalanceAmount: 200,
                cashReceiptItemNumber: 2,
            },
            {
                typeCode: 3,
                balanceAmount: 110,
                endDate: '2021-06-09',
                numberOfDaysCount: 970,
                startDate: '2021-06-09',
                unpaidInterestAmount: 630,
                interimBalanceAmount: 300,
                cashReceiptItemNumber: 3,
            },
        ],
    },
    borrowerCharges: [
        {
            code: '160',
            comment: '',
            indexNumber: 1,
            receivedAmount: 12,
            receivedDate: '2021-05-20',
            originalClaimSequenceNumber: 1,
            acceptableAmount: 160,
            acceptableDate: '2021-06-09',
            adjustedAmount: 89,
            adjustedDate: '2021-06-09',
            accruedInterestCalculations: [
                {
                    typeCode: 1,
                    endDate: '2021-06-09',
                    interestAmount: 35,
                    adjustedDefaultInterestRatePercent: 0.6425,
                    numberOfDaysCount: 690,
                    startDate: '2021-06-09',
                },
                {
                    typeCode: 2,
                    endDate: '2021-06-09',
                    interestAmount: 810,
                    adjustedDefaultInterestRatePercent: 1.4,
                    numberOfDaysCount: 580,
                    startDate: '2021-06-09',
                },
            ],
            creditOfReceiptInterestCalculation: {
                balanceAmount: 150,
                endDate: '2021-06-09',
                numberOfDaysCount: 240,
                startDate: '2021-06-09',
                unpaidInterestAmount: 420,
            },
        },
    ],
    borrowers: [
        {
            birthDate: '2021-05-20',
            claimBorrowerCategoryID: constants_2.ClaimBorrowerCategory.Covenantor,
            claimBorrowerTypeID: 1,
            defaultReasonCode: constants_2.DefaultReason.IllnessOrDeathOfTheBorrower,
            firstName: 'TESTBeagle',
            financialAssessmentCompletedFlag: false,
            indexNumber: 1,
            judgmentActionTypeCode: constants_2.JudgmentAction.Obtained,
            lastName: 'Ted',
        },
    ],
    cashReceipts: [
        {
            indexNumber: 1,
            receivedDate: '2021-05-20',
            receivedAmount: 1,
            comment: '',
            typeCode: cash_receipt_1.CashReceiptTypeCode.PartialPayment,
            admissibleAmount: 380,
            admissibleDate: '2021-06-09',
            partialPaymentAppliedToInterestAmount: 620,
            partialPaymentAppliedToTaxAmount: 160,
            partialPaymentAppliedToPrincipalAmount: 730,
        },
        {
            indexNumber: 2,
            receivedDate: '2021-05-20',
            receivedAmount: 1,
            comment: '',
            typeCode: cash_receipt_1.CashReceiptTypeCode.NetOperatingIncomeRentalIncome,
            admissibleAmount: 750,
            admissibleDate: '2021-06-09',
            partialPaymentAppliedToInterestAmount: 440,
            partialPaymentAppliedToTaxAmount: 98,
            partialPaymentAppliedToPrincipalAmount: 850,
        },
    ],
    defaultManagement: {
        approvedDate: '2021-05-20',
        toolAppliedFlag: true,
        toolDescription: 'abcd',
    },
    detail: {
        additionalSecuritiesHeldByBorrowerTypeCode: constants_2.AdditionalSecuritiesHeldByBorrower.ChattelMortgage,
        calendarDaysDeferredCount: 111,
        claimFilingExtensionObtainedFlag: false,
        claimTypeCode: constants_2.ClaimTypeCode.TitleTransfer,
        contestedFlag: false,
        evictionFlag: false,
        interestAdjustmentDate: '2021-05-20',
        legalActionCompletedDate: '2021-05-20',
        legalActionStartedDate: '2021-05-20',
        legalActionTypeCode: 4,
        legalSystemTypeCode: 2,
        mobileHomeOnLeasedLandFlag: true,
        mortgageTypeCode: 1,
        propertyOccupancyStatusCode: constants_2.PropertyOccupancyStatus.TenantOccupied,
        propertyTransferredByTypeCode: 1,
        propertyVacancyDate: '2021-05-20',
        propertyVacatedByTypeCode: constants_2.PropertyVacatedBy.Borrower,
        representativeToObtainKey: { fullName: 'First s', phoneNumber: '1234567890' },
        taxAccountBalanceTypeCode: 1,
        warrantyTypeCode: constants_2.WarrantyType.TitleInsurance,
    },
    documentAccessControlEntry: {
        authorUserControlEntryID: '00000000-0000-0000-0000-000000000000',
        internalUserControlEntryID: '00000000-0000-0000-0000-000000000000',
        externalUserControlEntryID: '00000000-0000-0000-0000-000000000000',
        masterUserControlEntryID: '00000000-0000-0000-0000-000000000000',
    },
    financialTransaction: {
        currentClaimPaymentAmount: 860,
        deficiencySaleLenderProceedAmount: 920,
        grossClaimPaymentAmount: 960,
        initialProvisionAmount: 990,
        netClaimPaymentAmount: 970,
        estimatedHoldingCostSaleCostAmount: 690,
        estimatedSaleProceedAmount: 140,
        grossMainClaimAmount: 460,
        netDeficiencyClaimPayableAmount: 420,
        provisionAmount: 450,
        receivableAmount: 13,
        saleCommissionValueAmount: 920,
    },
    indicator: {
        claimProcessingUnitTypeCode: constants_2.ClaimProcessUnitType.Multiple,
        claimReceivedDate: '2021-05-20',
        eddFemsiFlag: false,
        editsAndAllowancesFlag: true,
        enhancedAcppFlag: true,
        gvsPviiFlag: false,
        manualReviewRequiredFlag: false,
        notepadCommentFlag: false,
        paymentCount: 0,
        rffiFlag: false,
        underwritingInformationReceivedDate: '2021-05-20',
        underwritingInformationRequestedDate: '2021-05-20',
        underwritingReviewEndDate: '2021-05-20',
        underwritingReviewFlag: false,
        underwritingReviewStartDate: '2021-05-20',
    },
    lender: {
        address: {
            lineOneText: '122',
            lineTwoText: '2aa',
            municipalityName: '2',
            postalCode: 'A2V1S4',
            provinceCode: constants_1.StatisticsCanadaProvinceID.NewfoundlandAndLabrador,
        },
        approvedLenderCode: '60033',
        correspondenceLanguageCode: 1,
        authorizedOfficers: [
            {
                emailID: 'kjjk@h',
                extensionPhoneNumber: '11',
                faxNumber: '',
                firstName: 'Amit',
                lastName: 'Jambhulkar',
                phoneNumber: '1234567890',
                positionTypeCode: 1,
            },
        ],
        claimPayee: { payeeID: 12, name: '12345', transitNumber: '12345', typeCode: 1 },
    },
    listings: [{ appraisalDate: '2021-05-20', appraisalValue: 123, periodID: 1 }],
    mandatoryDocumentation: {
        completeClaimReceivedDate: '2021-05-20',
        completeMainClaimReceivedDate: '2021-05-20',
    },
    otherAdjustments: [
        {
            originalClaimSequenceNumber: 1,
            code: constants_1.OtherAdjustmentCode.ProcessTime,
            indexNumber: 1,
            amount: 990,
            date: '2021-06-09',
            numberOfDaysCount: 7,
        },
        {
            originalClaimSequenceNumber: 1,
            code: constants_1.OtherAdjustmentCode.LateFiling,
            indexNumber: 2,
            acceptableDate: '2021-06-09',
            amount: 690,
            date: '2021-06-09',
            numberOfDaysCount: -3,
        },
        {
            originalClaimSequenceNumber: 1,
            code: constants_1.OtherAdjustmentCode.LegalActionDelayFee,
            indexNumber: 3,
            acceptableDate: '2021-06-09',
            amount: 570,
            date: '2021-06-09',
            numberOfDaysCount: -8,
        },
        { originalClaimSequenceNumber: 1, code: constants_1.OtherAdjustmentCode.DEFSLOPT1DT, indexNumber: 4 },
        { originalClaimSequenceNumber: 1, code: constants_1.OtherAdjustmentCode.DEFSLOPT2DT, indexNumber: 5 },
    ],
    profile: {
        claimStatus: {
            code: constants_2.InternalClaimStatus.ReviewRequired,
            previousCode: constants_2.InternalClaimStatus.New,
            recordUpdatedTimestamp: '2021-06-09 17:51:59.443000',
        },
        submitterRecordCreatedTimestamp: '2021-06-09 17:51:59.272000',
        submitterUserID: 'b7e336bb-5c0f-4779-976f-a9acb5037fe4',
        submitterUserTypeCode: 1,
        dueDate: '2021-06-09',
    },
    property: {
        address: {
            additionalStreetNumber: '122',
            municipalityName: 'SHAWINIGAN',
            postalCode: 'G9T2Z2',
            provinceCode: constants_1.StatisticsCanadaProvinceID.Quebec,
            streetDirectionTypeCode: 5,
            streetName: '1RE',
            streetNumber: '840',
            streetTypeCode: 2,
            unitNumber: '',
        },
        bedCount: 0,
        buildingTypeCode: constants_1.BuildingType.Multiple,
        unitCount: 1,
    },
    validationResult: {
        claimCompletenessResultCode: 1,
        cmhcLoanAccountNumberMatchFlag: false,
        formCompletenessResultFlag: true,
        loanLevelValidationTypeCode: 1,
        processClaimInMicsResultFlag: false,
    },
    approval: {
        analyzedByUserID: '4d0866ae-8801-469e-8ec2-a6ab6b38e183',
        approverReviews: [],
        attachments: [],
        levelRequiredIndicator: 1,
        baseApprovalTitleTypeCode: 2,
        roleLevelAuthorityCheckIndicator: 1,
        stageIndicator: 1,
    },
    response: {
        decisionTypeCode: constants_1.DecisionTypeCode.Review,
        problems: [],
        autoAdjudicationOutcomeCode: 2,
    },
    suspenseConditions: [],
};
